import React, { Component } from 'react';
import _ from 'lodash';
import YTSearch from 'youtube-api-search';

import '../App.css';
import 'bootstrap/dist/css/bootstrap.css';
import SearchBar from './SearchBar';
import VideoList from './VideoList';
import VideoDetail from './VideoDetail';

const API_KEY = 'AIzaSyDZQAUzjaL8xdLCw41LGSD7S97k1m0mLnE';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      videos: [],
      selectedVideo: null
    };
    this.videoSearch('');
  }

  videoSearch(term) {
    YTSearch({ key: API_KEY, term }, videos =>
      this.setState(() => {
        return {
          videos,
          selectedVideo: videos[0]
        };
      })
    );
  }

  render() {
    const videoSearch = _.debounce(term => {
      this.videoSearch(term);
    }, 500);

    return (
      <div className="App">
        <header className="App-header">
          <h1 className="App-title">YouTube Browser</h1>
        </header>
        <div className="container">
          <p className="App-intro">Instant search of YouTube videos</p>
          <SearchBar onSearchTermChange={videoSearch} />
          <div className="row">
            <VideoDetail video={this.state.selectedVideo} />
            <VideoList
              videos={this.state.videos}
              onVideoSelect={selectedVideo =>
                this.setState(() => {
                  return { selectedVideo };
                })}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js